import { createSelector } from 'reselect';
import { RootState } from 'MyTypes';
import { State } from './reducer';

export const selectReportsState = (state: RootState): State => state.reports;

export const selectReportsList = createSelector(selectReportsState, (reports) => reports.reports);
